import React from 'react';

import { getPeriodForPresentation } from '../../services/utils';

class OrdersSection extends React.Component {

    getCounterpart(item, isSuperUser) {
        if (this.props.showCounerparty) {
            if (isSuperUser) {
                return ` Trading parties: ${item.creator_counterpart}, ${item.accepter_counterpart}.`;
            }
            else {
                return ` Counter party: ${item.contract_type != 'CME' ? item.counterpart : 'CME'}.`;
            }
        }
    }

    renderOrderLineText(order, units) {
        let orderType = order.intent == 'BUY' ? 'Bought' : 'Sold';
        if (this.props.showCreateButton) {
            orderType = order.intent == 'BUY' ? 'Bid' : 'Offer';
        } 
        return `${orderType}: ${getPeriodForPresentation(order.trading_period_prefix, order.trading_period)}. ${order.quantity} ${units}. ${order.price} ${order.currency_id}.`;
    }

    getContractId(order) {
        if (this.props.showCounerparty) {
            return ` Contract id: ${order.contract_numbers}`;
        }
    }

    render() {
        let { data, orders, createOrder, showCreateButton, isSuperUser } = this.props;

        return (
            <div className='online-market-container'>
                <div className='online-market-title'>{ data.short_name  + ' ('+data.unit_name+ ', ' + data.contract_type + ')'}</div>
                <div className='order-lines'>
                { orders && orders.length ? orders.map( item =>
                    <div
                        key={'product'+data.id+'_'+item.id}
                        onClick={this.props.openOrder.bind(this, item.id)}
                        className='online-market-line'>
                        { this.renderOrderLineText(item, data.unit_abbreviation) }
                        { this.getCounterpart(item, isSuperUser) }
                        { this.getContractId(item) }
                    </div>
                ) : null }
                </div>
                { showCreateButton ?
                <div onClick={createOrder} className='order-line-create'>Create an order</div>
                : null }
            </div>
        )
    }
}
export default OrdersSection;



// WEBPACK FOOTER //
// ./source/screens/orders/ordersSection.js